import AnimatedLink from "@components/animated-link";
import { Text, View } from "dripsy";
import * as React from "react";
import type { BaseScreen, ExtractRouteParams } from "react-native-ridge-navigation";

import ChevronRight from "./icons/chevron-right";

function Title<T extends BaseScreen>({
  title,
  greenTitle,
  subtitle,
  rightText,
  to,
  params,
}: {
  title: string;
  greenTitle?: string;
  subtitle?: string;
  rightText?: string;
  to?: T;
  params?: ExtractRouteParams<T["path"]>;
}) {
  return (
    <View sx={{ padding: "$2", px: 0 }}>
      <View
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <View sx={{ flexDirection: "row" }}>
          <Text
            sx={{
              maxWidth: 250,
              marginBottom: 0,
              fontSize: [18, 20, 24],
              fontWeight: "700",
              letterSpacing: 0.3,
            }}
          >
            {title}
          </Text>
          {greenTitle ? (
            <Text
              sx={{
                maxWidth: 250,
                marginBottom: 0,
                fontSize: [18, 20, 21],
                fontWeight: "700",
                color: "$primary",
              }}
            >
              {greenTitle}
            </Text>
          ) : null}
        </View>
        {to && (
          <AnimatedLink
            to={to}
            params={params}
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Text
              sx={{
                color: "$primary",
                fontSize: [14, 16],
                fontWeight: "600",
                marginRight: 10,
                letterSpacing: 0.4,
              }}
            >
              {rightText}
            </Text>
            {rightText ? <ChevronRight color="$primary" width={8} height={12} /> : null}
          </AnimatedLink>
        )}
      </View>
      {subtitle ? (
        <View sx={{ flex: 1 }}>
          <Text
            sx={{
              marginTop: 2,
              color: "$textGrey",
              fontSize: [14, 16, 18],
              flexWrap: "wrap",
            }}
          >
            {subtitle}
          </Text>
        </View>
      ) : null}
    </View>
  );
}

export default Title;
